import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap4-toggle/css/bootstrap4-toggle.min.css" // Import bootstrap4-toggle CSS
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr from "toastr"
import axios from "../../axios"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap"
import DeleteModal from "../../components/Common/DeleteModal"
import SweetAlert from "react-bootstrap-sweetalert"

function CategoryMaster() {
  const tokent =
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [duplicateerro, setduplicateerro] = useState(false)
  const [coutrysuccess, setcoutrysuccess] = useState(false)
  const [countryerror, setcountryerror] = useState(false)
  const [countryinfo, setcountryinfo] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [proid, setproid] = useState("")
  const [alltransportcollections, setalltransportcollections] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [allproductslists, setallproductslists] = useState({
    MainCategory_Description: "",
    Active: true,
    Created_By: "",
    Created_Date: "",
    Modify_By: "",
    Modify_Date: "",
  })

  useEffect(() => {
    Getallmaincatogry()
  }, [])

  const toggle = () => {
    if (modal) {
      setModal(false)
      validation.resetForm()
      setallproductslists({
        MainCategory_Description: "",
        Active: true,
        Created_By: "",
        Created_Date: "",
        Modify_By: "",
        Modify_Date: "",
      })
    } else {
      setModal(true)
    }
  }

  const handleUserClick = async arg => {
    const dataGot = arg
    setproid(dataGot.MainCategory_Id)
    setallproductslists({
      MainCategory_Description: dataGot.MainCategory_Description,
      MainCategory_Id: dataGot.MainCategory_Id,
      Active: dataGot.Active === "Y",
    })
    const GetoneMainCategory = await axios.instance
      .get(`/GetoneMainCategory/${dataGot.MainCategory_Id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        console.log(res.data)
        for (const data of res.data) {
          setproid(data.MainCategory_Id)
        }
      })
    setIsEdit(true)
    toggle()
  }

  const onClickDelete = user => {
    setdeletid(user.MainCategory_Id)
    setDeleteModal(true)
  }

  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: allproductslists,
    validationSchema: Yup.object({
      MainCategory_Description: Yup.string().required("Please Enter Category"),
    }),

    onSubmit: async values => {
      console.log("insdide submit")
      if (isEdit) {
        const update = await axios.instance
          .put(
            `/updateCategory/${proid}`,
            {
              MainCategory_Description: values.MainCategory_Description,
              Active: values.Active ? "Y" : "N",
              Modify_By: localStorage.getItem("UserId"),
              Modify_Date: new Date(),
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data === "") {
              Getallmaincatogry()
              toggle()
              setcountryinfo(true)
              validation.resetForm()
            } else {
              setduplicateerro(true)
            }
          })
      } else {
        console.log("insdide insert")
        const createoneuser = await axios.instance
          .post(
            "/InsertCategory",
            {
              MainCategory_Description: values.MainCategory_Description,
              Active: values.Active ? "Y" : "N",
              Created_By: localStorage.getItem("UserId"),
              Created_Date: new Date(),
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data.length === 1) {
              setcoutrysuccess(true)
              Getallmaincatogry()
              validation.resetForm()
              toggle()
            } else {
              setduplicateerro(true)
            }
          })
      }
      setDeleteModal(false)
    },
  })

  const DeleteCategory = async () => {
    const deleteoneuser = await axios.instance
      .delete(`/DeleteCategory/${deletid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data === "") {
          Getallmaincatogry()
          setDeleteModal(false)
          setcountryerror(true)
        } else {
          toastr.error(
            "Item is associated with existing records.",
            "Unable to delete"
          )
          setDeleteModal(false)
        }
      })
  }

  const Getallmaincatogry = async () => {
    const get = await axios.instance
      .get("/Getallmaincatogry", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setalltransportcollections(res.data)
      })
  }

  const columns = useMemo(
    () => [
      {
        Header: "Category",
        accessor: "MainCategory_Description",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Active",
        accessor: "Active",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const users = cellProps.row.original
                      onClickDelete(users)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={DeleteCategory}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master" breadcrumbItem="Category Master" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={alltransportcollections}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Category" : "Add Category"}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="12">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>Category </b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="MainCategory_Description"
                      className="form-control"
                      id="basicpill-card-verification-input"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.MainCategory_Description || ""}
                      invalid={
                        validation.touched.MainCategory_Description &&
                        validation.errors.MainCategory_Description
                          ? true
                          : false
                      }
                    />
                    {validation.touched.MainCategory_Description &&
                      validation.errors.MainCategory_Description && (
                        <FormFeedback type="invalid">
                          {validation.errors.MainCategory_Description}
                        </FormFeedback>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mt-4 mt-md-0">
                    <div className="vstack gap-2">
                      <div className="form-check form-switch form-switch-lg">
                        <Label
                          className="form-check-label"
                          htmlFor="activeSwitch"
                        >
                          Active
                        </Label>
                        <input
                          name="Active"
                          type="checkbox"
                          className="form-check-input"
                          id="activeSwitch"
                          checked={validation.values.Active}
                          onClick={() => {
                            const newActiveState = !validation.values.Active
                            console.log(
                              "Toggling Active state to:",
                              newActiveState
                            )
                            validation.setFieldValue("Active", newActiveState)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <div className="text-end">
                  {!!isEdit ? (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Add
                    </button>
                  )}
                </div>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>

      {duplicateerro ? (
        <SweetAlert
          title="Category  Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}

      {coutrysuccess ? (
        <SweetAlert
          title="Category Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcoutrysuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryinfo ? (
        <SweetAlert
          title="Category Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryerror ? (
        <SweetAlert
          title="Category Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryerror(false)
          }}
        ></SweetAlert>
      ) : null}
    </React.Fragment>
  )
}
CategoryMaster.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default CategoryMaster
